module.exports = __webpack_public_path__ + "static/media/passanger.6bc9ffb1.svg";